export default __webpack_public_path__ + "maps-examples-offline-storage-960-9f567c89f3467db624b88afd0930f348.webp";